/**
 * What an ORDER line's options add to its unit price — one rule for every
 * reader of an order (the model's getters, card L2/L3 itemization).
 *
 * THE VOCABULARY. An order modifier's `priceDelta` is the TOTAL for that
 * selection across its instances, and `selectedQuantity` is the count — never
 * multiplied again. That is how the till writes it
 * (`ModifierPricingHelper.buildOrderModifierGroup`: repeats collapse into one
 * modifier whose `priceDelta` is the SUM of per-instance deltas, "never price ×
 * qty"), how Books reads it (`financialTransactionSyncService`), and — since the
 * cart→order seam converts with `cartModifierSelectionTotal` — how a web order
 * is written. A reader that multiplied by `selectedQuantity` charged "Extra
 * Bacon ×2" twice over.
 */

/** Structural: the stored order line and the `OrderItem` model both fit. */
export interface OrderLineModifierSource {
  readonly modifierGroups?: ReadonlyArray<{
    readonly modifiers?: ReadonlyArray<{ readonly priceDelta?: number | null }> | null;
  }> | null;
}

/** The options' contribution to ONE unit of the line. */
export function orderLineModifiersTotal(item: OrderLineModifierSource): number {
  let total = 0;
  for (const group of item.modifierGroups ?? []) {
    for (const modifier of group.modifiers ?? []) {
      total += modifier.priceDelta ?? 0;
    }
  }
  return total;
}
